import * as React from "react";
import { Trash } from "lucide-react";

import { Media } from "@/services/bedrock";
import { MediaPlayer } from "@/components/MediaPlayer";

import "./styles.scss";

interface OwnProps {
  src: Media;
  id: number;

  handleClose: (id: number) => void;
  handleUpdate: (id: number, url: string) => void;
}

const VideoProjectMediaItemFC: React.FC<OwnProps> = ({ src, id, handleClose }: OwnProps) => {
  const isError = src.validAspectRatio === false;

  return (
    <div className="video-project-media-item-wrapper relative">
      <button
        type="button"
        className={`absolute top-2 right-2 flex items-center justify-center size-6 rounded-full text-white border-none outline-none transition-colors z-10 cursor-pointer shadow-3xs ${
          isError ? "bg-rose-600 hover:bg-rose-700" : "bg-slate-900/70 hover:bg-rose-600"
        }`}
        id={`${id}`}
        onClick={e => {
          e.stopPropagation();
          handleClose(id);
        }}
        title="Delete media"
      >
        <Trash className="size-3.5" />
      </button>
      <MediaPlayer media={src} />
    </div>
  );
};

export const VideoProjectMediaItem = VideoProjectMediaItemFC;
